import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "../components/DataTable";
import API from "../config/config";

const Brands = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        const response = await axios.get(API.ADMIN.BRANDS_LIST, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setBrands(response.data.brands);
      } catch (error) {
        console.error("Error fetching brands:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBrands();
  }, []);

  const handleDelete = async (brandId) => {
    try {
      await axios.delete(`${API.ADMIN.BRAND_DELETE}/${brandId}`);
      setBrands(brands.filter((brand) => brand._id !== brandId));
    } catch (error) {
      console.error("Error deleting brand:", error);
    }
  };

  const columns = [
    { Header: "Name", accessor: "name" },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (value ? "Yes" : "No"),
    },
  ];

  return (
    <DataTable
      data={brands}
      columns={columns}
      loading={loading}
      addLink="/vehicles/brands/add"
      editPath="/vehicles/brands/edit"
      showDeleteButton={false}
    />
  );
};

export default Brands;
